/**
 * Model Management API functions
 */
import { ENDPOINTS } from './endpoints';
import { getRequestBackendDataV2, postRequestBackendDataV2 } from './core';
import logger from '../utils/logger';

export async function getCopilotModels(auth, callback) {
    await getRequestBackendDataV2(auth, callback, ENDPOINTS.MODELS.LIST);
}

// Alias for backward compatibility
export const getAvailableModelsV2 = getCopilotModels;

export async function createCopilotModel(auth, callback, model) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.MODELS.LIST, model);
}

export async function updateCopilotModel(auth, callback, modelId, model) {
    if (typeof callback !== 'function') {
        logger.error('Callback is not a function in updateCopilotModel');
        return;
    }
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.MODELS.BY_ID(modelId), model, 'PUT');
}

export async function deleteCopilotModel(auth, callback, modelId) {
    await postRequestBackendDataV2(auth, callback, ENDPOINTS.MODELS.BY_ID(modelId), null, 'DELETE');
}

